export const OPTIMIZATION_INITIALIZATION_TIMEOUT_MS = 4000;
